import { Injectable } from '@angular/core';

export enum StorageKeys {
  inventoryFilters = 'filters_inventory',
  salesFilters = 'filters_sales',
  purchasesFilters = 'filters_purchases',
  paymentsFilters = 'filters_payments',
  dashboardFilters = 'filters_dashboard',
  sharedReportsFilters = 'filters_shared_reports',
  generalReportsFilters = 'filters_general_reports',
  sportsReportsFilters = 'filters_sports_reports',
  eventsSelection = 'selected_events',
  insightsSelection = 'insights_report',
}

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  get<T>(key: string): T | null {
    const item = sessionStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  }

  set<T>(key: string, value: T): void {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      console.error(`Failed to save ${key} to local storage`, e);
    }
  }

  remove(key: string): void {
    sessionStorage.removeItem(key);
  }

  clear(): void {
    sessionStorage.clear();
  }
}
